import UploadResource from 'models/upload/resource';
import React from 'react';

interface UploadsDef {
  deleteUpload: (company: UploadResource) => Promise<void>;
}
export const Context = React.createContext<UploadsDef>({
  deleteUpload: async () => undefined,
});

export default Context;

export interface SelectionValue {
  deleting?: UploadResource;

}

export interface SelectionContextValue {
  selection: SelectionValue;
  setSelection: (value: SelectionValue) => void;
}

export const SelectionContext = React.createContext<SelectionContextValue>({
  selection: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelection: () => {},
});
